/* global $:false */

import { DEV_MODE } from './helpers/cob.devmode.js';
import Translator from './helpers/cob.translator.js';
import utils from './cob.utils.js';

// # cob.UI
var ui = {};

// ## ui.Slider
ui.slider = (function() {
    var _latch;

    var _animateDown = function($old, $new) {
        $old.hide('slide', {
            direction: "up"
        }, 600, _latch.countDown);

        $new.show('slide', {
            direction: "down"
        }, 600, _latch.countDown);
    };

    var _animateUp = function($old, $new) {
        $old.hide('slide', {
            direction: "down"
        }, 600, _latch.countDown);

        $new.show('slide', {
            direction: "up"
        }, 600, _latch.countDown);
    };

    var _animateRight = function($old, $new) {
        $old.hide('slide', {
            direction: "left"
        }, 600, _latch.countDown);

        $new.show('slide', {
            direction: "right"
        }, 600, _latch.countDown);
    };

    var _animateLeft = function($old, $new) {
        $old.hide('slide', {
            direction: "right"
        }, 600, _latch.countDown);

        $new.show('slide', {
            direction: "left"
        }, 600, _latch.countDown);
    };

    return{
        slide: function(slideDirection, $old, $new, callbackFn) {

            if ($new.hasClass("hidden")) {
                $new.removeClass("hidden");
            }

            _latch = new utils.CountdownLatch(2, callbackFn, "slider");

            switch (slideDirection) {
                case 'down':
                    _animateDown($old, $new);
                    break;
                case 'up':
                    _animateUp($old, $new);
                    break;
                case 'left':
                    _animateLeft($old, $new);
                    break;
                case 'right':
                    _animateRight($old, $new);
                    break;
            }
        }
    };
}());

// ## ui.Notification
ui.notification = (function() {
    var _translator,
        _defaultErrorTitle,
        _defaultWarningTitle,
        _defaultInfoTitle,
        _error400,
        _error403,
        _error405,
        _error409,
        _error500,
        _errorServerDown;

    var time = 2500;

    var _showNotification = function(level, data) {
        if (!data.sticky) {
            data.time = time;
        }

        if (level === 'info') {
            data.title = _defaultInfoTitle;
            data.class_name = "notification-info";
        } else if (level === 'warn') {
            data.title = _defaultWarningTitle;
            data.class_name = "notification-warn";
        } else {
            data.title = _defaultErrorTitle;
            data.class_name = "notification-error";
        }

        if($.mobile){
            window.console.log(JSON.stringify(data));
        }else{
            $.gritter.add(data);
        }
    };

    var _showCustom = function(level, title, message, isSticky) {
        var data = {};

        if (isSticky) {
            data.time = time;
        }

        data.title = title;
        data.text = message;

        if (level === 'info') {
            data.class_name = "notification-info";

        } else if (level === 'warn') {
            data.class_name = "notification-warn";

        } else {
            data.class_name = "notification-error";
        }

        if ($.mobile) {
            window.console.log(JSON.stringify(data));
        } else {
            $.gritter.add(data);
        }
    };


    var _showStandardErrorsFor = function(req) {
        if (req.status === 400) {
            _showNotification('error', { title: _defaultErrorTitle, text: _error400});

        } else if (req.status === 403) {
            _showNotification('error', { title: _defaultErrorTitle, text: _error403});

        } else if (req.status === 405) {
            _showNotification('error', { title: _defaultErrorTitle, text: _error405});

        } else if (req.status === 409) {
            _showNotification('warn', { title: _defaultErrorTitle, text: _error409});

        } else if (req.status === 0) {
            _showNotification('error', { title: _defaultErrorTitle, text: _errorServerDown});

        } else {
            _showNotification('error', { title: _defaultErrorTitle, text: _error500});
        }
    };

    var _init = function() {
        _translator = new Translator(
           (new URL(document.location)).searchParams.get("lang"),
           (new URL(document.location)).searchParams.get("locale")
        );
        _translator.loadLanguage(function() {
            _defaultErrorTitle = _translator.translateString('cob.error.codes', "title.error");
            _defaultWarningTitle = _translator.translateString('cob.error.codes', "title.warning");
            _defaultInfoTitle = _translator.translateString('cob.error.codes', "title.info") || 'Info';
            _error400 = _translator.translateString('cob.error.codes', 'generic.400');
            _error403 = _translator.translateString('cob.error.codes', 'generic.403');
            _error405 = _translator.translateString('cob.error.codes', 'generic.405');
            _error409 = _translator.translateString('cob.error.codes', 'generic.409');
            _error500 = _translator.translateString('cob.error.codes', 'generic.500');
            _errorServerDown = _translator.translateString('cob.error.codes', 'generic.0');
        });
    };
    _init();

    var _getTranslatedMessageWithReplacedVars = function(module, error) {
        var translatedMessage = _translator.translateString(module, error.errorCode);
        if (!translatedMessage)translatedMessage = error.errorCode;
        var key, value;
        for (key in error) {
            if (error.hasOwnProperty(key)) {
                value = error[key];
                translatedMessage = translatedMessage.replace(new RegExp('\\$\\[' + key + '\\]', "g"), value);
            }
        }
        return translatedMessage;
    };

    return {
        showWarning: function(notification, isSticky) {
            this.showNotification('warn', notification, isSticky);
        },
        showError: function(notification, isSticky) {
            this.showNotification('error', notification, isSticky);
        },
        showInfo: function(notification, isSticky) {
            this.showNotification('info', notification, isSticky);
        },
        showCustom: _showCustom,
        showNotifications: function(level, notifications) {
            var errorMsg = '';
            if (notifications.errorCode) {
                errorMsg = _getTranslatedMessageWithReplacedVars('cob.error.codes', notifications);

            } else if (notifications.errors) {
                notifications.errors.forEach(function(el) {
                    errorMsg = errorMsg + _getTranslatedMessageWithReplacedVars('cob.error.codes', el) + '<br/>';
                });
            }
            if (errorMsg) {
                _showNotification(level, {text: errorMsg});
            } else {
                window.console.log("error message is void...");
                window.console.log(notifications);
            }
        },
        showNotificationsFromRequest: function(level, req) {

            if (req.responseText) {
                try {
                    var errors = JSON.parse(req.responseText);
                    // We only want to show non standard error notification if the request returned a recognizable error object
                    if(errors.errorCode || errors.errors){
                        this.showNotifications(level, errors);
                    }else{
                        _showStandardErrorsFor(req);
                    }
                } catch (exception) {
                    _showStandardErrorsFor(req);
                }
            } else {
                _showStandardErrorsFor(req);
            }
        },
        showNotification: function(level, msg, isSticky) {
            _showNotification(level, {text: msg, sticky: isSticky});
        },
        notifyServerDown: function() {
            _showStandardErrorsFor({status: 0});
        }
    };
})();

// ## ui.Dialog
ui.Dialog = function(html, props) {
    var _dialog;

    return {
        show: function() {
            var _thisProps = props;
            if (!_thisProps) {
                _thisProps = {};
            }

            var _this = this;
            if (!_thisProps.close) {
                _thisProps.close = function() {
                    _this.close();
                };
            }

            _dialog = $(html).dialog(props);
        },
        close: function() {
            _dialog.dialog("destroy").remove();
        }
    };
};

// ## ui.Binding
ui.Binding = function(model) {
    return {
        register: function(event, $el, property) {
            $el.bind(event, function() {
                var capitalizedProp = property.charAt(0).toUpperCase() + property.slice(1);
                //first test for specific setters : setOption(value);
                var parentModel = model.getParent();
                if (typeof parentModel["set" + capitalizedProp] === 'function') {
                    parentModel["set" + capitalizedProp]($el.val());
                } else {
                    model[property] = $el.val();
                }

            });
        }
    };
};

// ## ui.IframeResizer
ui.IframeResizer = function(cobapp, iframeSelector, margin, anchor) {
    if (cobapp.isInIframe()) {
        DEV_MODE && window.console.log("IFrameResizer: starting resizer for iframe " + iframeSelector);

        var _stopped = false;

        var _getIFrameContentHeight = function(iframe) {
            //**hack**: set small height first for better height recalculation
            iframe.height(30);

            return document.body.parentNode.scrollHeight + 30;

        };

        //{shrinkToFit:true, stop:true}
        var _resizeToFit = function(options) {
            var lastResize = false;
            var shrinkToFit = false;
            if (options) {
                if (options.stop) lastResize = true;
                if (options.start) _stopped = false;
                if (options.shrinkToFit) shrinkToFit = true;
            }

            if (!_stopped) {

                window.setTimeout(function() {
                    var theFrame = $(iframeSelector, parent.document.body);

                    var viewportHeight = $(parent.window).height();

                    if (shrinkToFit) {
                        var iframeContentHeight = _getIFrameContentHeight(theFrame);
                        theFrame.height(Math.min(iframeContentHeight, viewportHeight - margin));
                    } else {
                        theFrame.height(viewportHeight - margin);
                        if (anchor) parent.window.location.hash = "#" + anchor;
                    }

                }, 200);

                if (lastResize) _stopped = true;
            }
        };

        var _receiveEvent = function(event, ops) {
            _resizeToFit(ops);
        };

        cobapp.subscribe("recordm-integration-resize-to-fit", _receiveEvent);

    } else {
        DEV_MODE && window.console.log("IFrameResizer: someone instantiated me, but I'm not inside an iFrame!! I will do no such thing!");
    }
};

export default ui;
